import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import {IntlProvider} from "react-intl";
import configureStore from './store/configureStore.js';
import AppContainer from './containers/AppContainer';
import 'bootstrap/dist/css/bootstrap.css';
import './css/vendor/font-awesome/css/font-awesome.css';
require(`./assets/${process.env.PAGE}/css/form.css`)
require(`./assets/${process.env.PAGE}/css/custom-header.css`);
require(`./assets/${process.env.PAGE}/css/customs.css`);
import messages_mtmr from "./translations/montemar.json";
import messages_mtmr_adelantos from "./translations/montemar-adelantos.json";
import messages_puedo from "./translations/puedo.json";
import messages_demo from "./translations/demo.json";

const messages = {
	'montemar': messages_mtmr,
	'montemar-adelantos': messages_mtmr_adelantos,
    'puedo': messages_puedo,
    'demo': messages_demo
};

const store = configureStore();

ReactDOM.render(
	<IntlProvider locale={'en'} messages={messages[process.env.PAGE]}>
	    <Provider store={store}>
	        <AppContainer/>
	    </Provider>
	</IntlProvider>,

    document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/